import axiosInstance from '../axiosConfig';

const authService = {
    login: async (credentials) => {
        const response = await axiosInstance.post('/auth/login', credentials);
        return response.data;
    },

    register: async (userData) => {
        const response = await axiosInstance.post('/auth/register', userData);
        return response.data;
    },

    getProfile: async () => {
        const response = await axiosInstance.get('/auth/getProfile');
        return response.data;
    },

    updateProfile: async (data) => {
        const response = await axiosInstance.put('/auth/profile', data);
        return response.data;
    },

    refresh: async () => {
        const response = await axiosInstance.post('/auth/refresh');
        return response.data;
    },

    logout: async () => {
        try {
            await axiosInstance.post('/auth/logout');
        } catch (_) {
            // Best-effort — always clear local state even if server call fails
        }
        localStorage.removeItem('token');
    }
};

export default authService;
